import { Injectable, Inject, PLATFORM_ID } from '@angular/core';

import { environment } from 'src/environments/environment';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private iss = environment.iss;

  constructor(@Inject(PLATFORM_ID) private platformId: {}) {}

  public handle(token): boolean {
    this.set(token);
    return this.isValid();
  }

  public set(token): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('token', token);
    }
  }

  public get(): string {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem('token');
    }
    return '';
  }

  public remove(): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('token');
    }
  }

  public loggedIn(): boolean {
    return this.isValid();
  }

  private isValid(): boolean {
    const token = this.get();
    if (!token) {
      return false;
    }

    const payload = this.payload(token);
    if (payload?.iss) {
      return Object.values(this.iss).indexOf(payload.iss) > -1;
    }

    return this.hasValidStoredUser();
  }

  private payload(token): any {
    if (token.split('.').length !== 3) {
      return null;
    }

    const payload = token.split('.')[1];
    return this.decode(payload);
  }

  private decode(payload): any {
    try {
      return JSON.parse(atob(payload));
    } catch {
      return null;
    }
  }

  private hasValidStoredUser(): boolean {
    if (!isPlatformBrowser(this.platformId)) {
      return false;
    }

    const currentUser = localStorage.getItem('currentUser');
    if (!currentUser) {
      return false;
    }

    try {
      const parsedUser = JSON.parse(currentUser);
      return (
        !!parsedUser?.expires && Number(parsedUser.expires) > Date.now() / 1000
      );
    } catch {
      return false;
    }
  }
}
